export default [
  {
    path: '/survey',
    component: () => import('./views/Index'),
    name: 'survey',
    redirect: { name: 'survey-list' },
    children: [
      {
        path: 'survey-list',
        name: 'survey-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'auth',
        },
      },
      {
        path: 'survey/:survey_id',
        name: 'survey-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'auth',
        },
      },
    ],
  },
]
